import * as Icons from './icon-definitions';

export const itemIdToIconsMap = {
  206093715: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_DRAWER, Icons.DUAL_COOLING_TEMPERATURE_CONTROL],
    C: [Icons.DUAL_COOLING_COOLING_SYSTEM, Icons.MEASURED_WATER_FILL, Icons.IN_DOOR_ICE_MAKER],
  },
  206452443: {
    B: [Icons.TEMPERATURE_CONTROL, Icons.PANTRY_DRAWER, Icons.GALLON_DOOR_BINS],
    C: [Icons.SMART_COOLING, Icons.PANTRY_DRAWER, Icons.GALLON_DOOR_BINS],
  },
  303280036: {
    B: [Icons.SMART_FEATURES, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.FINGERPRINT_RESISTANT, Icons.GALLON_DOOR_BINS, Icons.FULL_WIDTH_DRAWER],
  },
  304923652: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.SLIDE_OUT_SHELF, Icons.DELI_DRAWER],
    C: [Icons.SLIDE_OUT_SHELF, Icons.DELI_DRAWER, Icons.WATER_DISPENSER],
  },
  304923653: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.RETRACTABLE_SHELF],
    C: [Icons.RETRACTABLE_SHELF, Icons.FULL_WIDTH_DRAWER, Icons.EXTERNAL_WATER_DISPENSER],
  },
  305142002: {
    B: [Icons.ICE_MAKER, Icons.WATER_DISPENSER, Icons.FAST_COOLING],
    C: [Icons.FAST_COOLING, Icons.RETRACTABLE_SHELF, Icons.FULL_WIDTH_DRAWER],
  },
  305608916: {
    B: [Icons.ICE_MAKER, Icons.WATER_DISPENSER, Icons.PORTABLE_DOOR_BIN],
    C: [Icons.EXTERNAL_WATER_DISPENSER, Icons.PORTABLE_DOOR_BIN, Icons.RETRACTABLE_SHELF],
  },
  310324783: {
    B: [Icons.PYRAMID_ICE_MAKER, Icons.DUAL_COOLING_TEMPERATURE_CONTROL, Icons.FRESHNESS_SYSTEM],
    C: [Icons.DUAL_COMPRESSORS_COOLING_SYSTEM, Icons.PYRAMID_ICE, Icons.FRESHNESS_SYSTEM],
  },
  310324792: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.DUAL_COOLING_TEMPERATURE_CONTROL, Icons.FRESHNESS_SYSTEM],
    C: [Icons.DUAL_COMPRESSORS_COOLING_SYSTEM, Icons.FRESHNESS_SYSTEM, Icons.INTERNAL_WATER_DISPENSER],
  },
  310324797: {
    B: [Icons.PYRAMID_ICE_MAKER, Icons.DUAL_COMPRESSORS_TEMPERATURE_CONTROL, Icons.INTERNAL_WATER_DISPENSER],
    C: [Icons.DUAL_COOLING_COOLING_SYSTEM, Icons.INTERNAL_WATER_DISPENSER, Icons.PYRAMID_ICE],
  },
  312648552: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.DUAL_COOLING_TEMPERATURE_CONTROL],
    C: [Icons.DUAL_COOLING_COOLING_SYSTEM, Icons.FAST_CHILL, Icons.IN_DOOR_ICE_MAKER],
  },
  313803342: {
    B: [Icons.ICE_MAKER, Icons.TEMPERATURE_CONTROL, Icons.FAST_COOLING],
    C: [Icons.FAST_COOLING, Icons.VACATION_MODE, Icons.EVEN_COOLING],
  },
  315868024: {
    B: [Icons.INTERNAL_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.DUAL_COOLING_TEMPERATURE_CONTROL],
    C: [Icons.DUAL_COOLING_COOLING_SYSTEM, Icons.FINGERPRINT_RESISTANT, Icons.FIVE_FIVE_LBS_ICE_CAPACITY],
  },
  318840093: {
    B: [Icons.ICE_MAKER, Icons.TEMPERATURE_CONTROL, Icons.AUTO_CLOSE_DOORS],
    C: [Icons.AUTO_CLOSE_DOORS, Icons.SEALED_CRISPERS, Icons.THREE_TIER_FREEZER],
  },
  319240389: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.FAST_COOLING],
    C: [Icons.IN_DOOR_ICE_MAKER, Icons.FAST_COOLING, Icons.RETRACTABLE_SHELF],
  },
  319341358: {
    B: [Icons.WI_FI_ENABLED, Icons.ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.WI_FI_ENABLED, Icons.SOFT_CLOSE_DRAWERS],
  },
  319502657: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_DRAWER, Icons.DUAL_COOLING_TEMPERATURE_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.FIVE_TEMP_DRAWER, Icons.AUTO_FILL_PITCHER],
  },
  319503087: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_DRAWER, Icons.TEMPERATURE_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.FIVE_TEMP_DRAWER, Icons.CUSTOMIZABLE_PANELS],
  },
  319503272: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_DRAWER, Icons.DUAL_COOLING_TEMPERATURE_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.CONVERTIBLE_DRAWER, Icons.AUTO_FILL_PITCHER],
  },
  319503316: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_DRAWER, Icons.INDEPENDENT_TEMP_CONTROLS],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.CUSTOMIZABLE_PANELS, Icons.ADJUSTABLE_TEMP_DRAWER],
  },
  319503467: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_DRAWER, Icons.DUAL_COOLING_TEMPERATURE_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.CUSTOMIZABLE_PANELS, Icons.AUTO_FILL_PITCHER],
  },
  319881459: {
    B: [Icons.CONVERTIBLE_COMPARTMENT, Icons.TEMPERATURE_CONTROL, Icons.TWO_FREEZER_DRAWERS],
    C: [Icons.ADJUSTABLE_TEMP_DRAWER, Icons.FAST_COOLING, Icons.TWO_FREEZER_DRAWERS],
  },
  319923732: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.DIGITAL_TEMP_CONTROL, Icons.CUSTOMIZABLE_PANELS],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.CUSTOMIZABLE_PANELS, Icons.AUTO_FILL_PITCHER],
  },
  320020783: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.CUSTOMIZABLE_PANELS],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.AUTO_FILL_PITCHER, Icons.CUSTOMIZABLE_PANELS],
  },
  320020843: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.CUSTOMIZABLE_PANELS],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.CUSTOMIZABLE_PANELS, Icons.AUTO_FILL_PITCHER],
  },
  320154264: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_COMPARTMENT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.THREE_TEMP_DRAWER, Icons.ETHYLENE_FILTER],
  },
  320154348: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.ADJUSTABLE_TEMP_DRAWER, Icons.TEMPERATURE_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.AUTO_CLOSE_DOORS, Icons.THREE_TEMP_DRAWER],
  },
  320155533: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.ADJUSTABLE_TEMP_DRAWER, Icons.DIGITAL_TEMP_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.THREE_TEMP_DRAWER, Icons.GARAGE_READY],
  },
  320629083: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_COMPARTMENT, Icons.AUTO_CLOSE_DOORS],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.AUTO_CLOSE_DOORS, Icons.REVERSIBLE_CRISPER],
  },
  322038287: {
    B: [Icons.ICE_MAKER, Icons.WI_FI_ENABLED, Icons.TWO_SIX_CU_FT],
    C: [Icons.TWO_SIX_CU_FT, Icons.WI_FI_ENABLED, Icons.AIR_FILTER],
  },
  325158107: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.WI_FI_ENABLED, Icons.DIGITAL_TEMP_CONTROL],
    C: [Icons.TRIPLE_ICE_MAKER, Icons.THREE_TIER_FREEZER, Icons.AIR_FILTER],
  },
  325158140: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.DIGITAL_TEMP_CONTROL, Icons.THREE_TIER_FREEZER],
    C: [Icons.TRIPLE_ICE_MAKER, Icons.PRECISION_COOLING, Icons.THREE_TIER_FREEZER],
  },
  325158253: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.SMART_FEATURES, Icons.TEMPERATURE_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.WI_FI_ENABLED, Icons.FAST_ICE_FAST_ICE_PRODUCTION],
  },
  325158270: {
    B: [Icons.SMART_FEATURES, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.WI_FI_ENABLED, Icons.FINGERPRINT_RESISTANT, Icons.SPACE_SAVING_ICE],
  },
  325158283: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.DIGITAL_TEMP_CONTROL],
    C: [Icons.TRIPLE_ICE_MAKER, Icons.PRECISE_TEMP_CONTROL, Icons.FAST_ICE_FAST_ICE_PRODUCTION],
  },
  325792367: {
    B: [Icons.ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.CONVERTIBLE_DRAWER],
    C: [Icons.FIVE_TEMP_DRAWER, Icons.DUAL_COOLING_COOLING_SYSTEM, Icons.PIZZA_STORAGE],
  },
  325792387: {
    B: [Icons.ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.ADJUSTABLE_TEMP_DRAWER],
    C: [Icons.ADJUSTABLE_TEMP_DRAWER, Icons.DUAL_EVAPORATORS, Icons.SOFT_CLOSE_DRAWERS],
  },
  326195120: {
    B: [Icons.WI_FI_ENABLED, Icons.TEMPERATURE_CONTROL, Icons.TWO_ICE_TYPES],
    C: [Icons.WI_FI_ENABLED, Icons.TWO_ICE_TYPES, Icons.RETRACTABLE_SHELF],
  },
  326195150: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.WI_FI_ENABLED, Icons.SLIDE_IN_SHELF],
    C: [Icons.WI_FI_ENABLED, Icons.SLIDE_IN_SHELF, Icons.WATER_DISPENSER],
  },
  326195161: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.WI_FI_ENABLED, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.FOUR_ICE_TYPES, Icons.ENERGY_MONITORING, Icons.EVEN_COOLING],
  },
  326403750: {
    B: [Icons.ICE_MAKER, Icons.WI_FI_ENABLED, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.ADJUSTABLE_TEMP_DRAWER, Icons.DUAL_COOLING_COOLING_SYSTEM, Icons.WI_FI_ENABLED],
  },
  326523737: {
    B: [Icons.ICE_MAKER, Icons.WATER_DISPENSER, Icons.PANTRY_DRAWER],
    C: [Icons.INTERNAL_WATER_DISPENSER, Icons.PANTRY_DRAWER, Icons.FRAMELESS_SHELVES],
  },
  326597313: {
    B: [Icons.ICE_MAKER, Icons.WATER_DISPENSER, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.INTERNAL_WATER_DISPENSER, Icons.PRODUCE_PRESERVER, Icons.FULL_WIDTH_DRAWER],
  },
  326598423: {
    B: [Icons.ICE_MAKER, Icons.WATER_DISPENSER, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.INTERNAL_WATER_DISPENSER, Icons.PRODUCE_PRESERVER, Icons.FULL_WIDTH_DRAWER],
  },
  326917144: {
    B: [Icons.ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.CONVERTIBLE_DRAWER],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.SOFT_CLOSE_DOORS, Icons.PRECISION_COOLING],
  },
  327169029: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.FULL_WIDTH_DRAWER],
    C: [Icons.PRECISE_TEMP_CONTROL, Icons.TALL_DISPENSER, Icons.SLIM_IN_DOOR_ICE_MAKER],
  },
  327175337: {
    B: [Icons.ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.PRECISE_TEMP_CONTROL, Icons.FULL_WIDTH_DRAWER, Icons.FAST_ICE_FAST_ICE_PRODUCTION],
  },
  328283862: {
    B: [Icons.ICE_MAKER, Icons.WI_FI_ENABLED, Icons.CONVERTIBLE_ZONE],
    C: [Icons.CONVERTIBLE_ZONE, Icons.ONE_TWO_FIVE_LBS_ICE_CAPACITY, Icons.TRIPLE_EVAPORATORS],
  },
  328401721: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.WATER_DISPENSER, Icons.WI_FI_ENABLED],
    C: [Icons.CONVERTIBLE_ZONE, Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.AUTO_OPEN_DOOR],
  },
  328402054: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.WATER_DISPENSER, Icons.WI_FI_ENABLED],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.CONVERTIBLE_ZONE, Icons.CUSTOMIZABLE_PANELS],
  },
  328402200: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.WATER_DISPENSER, Icons.WI_FI_ENABLED],
    C: [Icons.INTERNAL_CAMERA, Icons.AUTO_OPEN_DOOR, Icons.CONVERTIBLE_ZONE],
  },
  329624985: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.SABBATH_MODE],
    C: [Icons.IN_DOOR_ICE_MAKER, Icons.SABBATH_MODE, Icons.SLIDE_OUT_SHELF],
  },
  329741314: {
    B: [Icons.ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.ADJUSTABLE_TEMP_DRAWER],
    C: [Icons.AUTO_CLOSE_DOORS, Icons.ADJUSTABLE_TEMP_DRAWER, Icons.ETHYLENE_FILTER],
  },
  329904698: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.CONVERTIBLE_COMPARTMENT],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.SOFT_CLOSE_DOORS, Icons.WATER_AND_ICE_DISPENSER],
  },
  330262476: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.CONVERTIBLE_COMPARTMENT],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.SOFT_CLOSE_DOORS],
  },
  330559807: {
    B: [Icons.ICE_DISPENSER, Icons.CONVERTIBLE_COMPARTMENT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.SOFT_CLOSE_DOORS, Icons.INTERNAL_ICE_DISPENSER],
  },
  331842846: {
    B: [Icons.INTERNAL_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.FULL_WIDTH_DRAWER],
    C: [Icons.INTERNAL_ICE_DISPENSER, Icons.FAST_ICE_FAST_ICE_PRODUCTION, Icons.FULL_WIDTH_DRAWER],
  },
  331843223: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.SPACE_SAVING_ICE, Icons.TALL_DISPENSER, Icons.FAST_ICE_FAST_ICE_PRODUCTION],
  },
  331843284: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.TALL_DISPENSER, Icons.SPACE_SAVING_ICE, Icons.FAST_ICE_FAST_ICE_PRODUCTION],
  },
  331921569: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_COMPARTMENT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.ADJUSTABLE_TEMP_DRAWER, Icons.HIGH_CAPACITY_ICE, Icons.MEASURED_WATER_FILL],
  },
  332050096: {
    B: [Icons.FAST_ICE_ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.FAST_ICE_PRODUCTION, Icons.ODOR_FILTER, Icons.ONE_TOUCH_BOTTLE_FILL],
  },
  332315115: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.TWO_TIER_FREEZER],
    C: [Icons.INTERNAL_WATER_DISPENSER, Icons.TWO_TIER_FREEZER, Icons.FINGERPRINT_RESISTANT],
  },
  332375001: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.CONVERTIBLE_COMPARTMENT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.ADJUSTABLE_TEMP_DRAWER, Icons.MEASURED_WATER_FILL, Icons.THREE_SEVEN_LBS_ICE_CAPACITY],
  },
  332375341: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.ADJUSTABLE_TEMP_DRAWER],
    C: [Icons.ADJUSTABLE_TEMP_DRAWER, Icons.AUTO_FILL_DISPENSER, Icons.THREE_SEVEN_LBS_ICE_CAPACITY],
  },
  332464407: {
    B: [Icons.ICE_MAKER, Icons.WI_FI_ENABLED, Icons.ADJUSTABLE_TEMP_DRAWER],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.DUAL_COOLING_COOLING_SYSTEM, Icons.WI_FI_ENABLED],
  },
  332465544: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.ADJUSTABLE_TEMP_DRAWER, Icons.SOFT_CLOSE_DRAWERS],
    C: [Icons.AUTO_FILL_PITCHER, Icons.ADJUSTABLE_TEMP_DRAWER, Icons.SOFT_CLOSE_DRAWERS],
  },
  332467887: {
    B: [Icons.ICE_MAKER, Icons.WI_FI_ENABLED, Icons.CONVERTIBLE_DRAWER],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.WI_FI_ENABLED, Icons.DUAL_EVAPORATORS],
  },
  332854084: {
    B: [Icons.SMART_FEATURES, Icons.TEMPERATURE_CONTROL, Icons.SLIDE_IN_SHELF],
    C: [Icons.WI_FI_ENABLED, Icons.SLIDE_IN_SHELF, Icons.ENERGY_SAVING_MODE],
  },
  333389416: {
    B: [Icons.ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.ODOR_FILTER, Icons.ONE_TOUCH_BOTTLE_FILL, Icons.TWO_TIER_FREEZER],
  },
  333935771: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.INTERNAL_WATER_DISPENSER, Icons.WI_FI_ENABLED],
    C: [Icons.CUSTOMIZABLE_PANELS, Icons.CONVERTIBLE_DRAWER, Icons.AUTO_FILL_PITCHER],
  },
  333935785: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.WI_FI_ENABLED, Icons.CONVERTIBLE_DRAWER],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.AUTO_FILL_PITCHER, Icons.CUSTOMIZABLE_PANELS],
  },
  333935834: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.WATER_DISPENSER, Icons.CONVERTIBLE_DRAWER],
    C: [Icons.THREE_TWO_IN_TOUCHSCREEN, Icons.FOOD_RECOGNITION_CAMERA, Icons.AUTO_OPEN_DOOR],
  },
  333935897: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.WATER_DISPENSER, Icons.CONVERTIBLE_DRAWER],
    C: [Icons.AUTO_OPEN_DOOR, Icons.FOOD_RECOGNITION_CAMERA, Icons.CONVERTIBLE_DRAWER],
  },
  333935909: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.WATER_DISPENSER, Icons.CONVERTIBLE_DRAWER],
    C: [Icons.FOOD_RECOGNITION_CAMERA, Icons.AUTO_OPEN_DOOR, Icons.THREE_TWO_IN_TOUCHSCREEN],
  },
  334291636: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.AIR_FILTER],
    C: [Icons.INTERNAL_WATER_DISPENSER, Icons.TEMP_CONTROL, Icons.AIR_FILTER],
  },
  334293585: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.FULL_WIDTH_DRAWER, Icons.PROACTIVE_ALERTS, Icons.DUAL_CRISPERS],
  },
  334293948: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.DUAL_ICE_MAKER_ICE_MAKER],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.TALL_DISPENSER, Icons.SLIM_IN_DOOR_ICE_MAKER],
  },
  334604883: {
    B: [Icons.TEMPERATURE_CONTROL, Icons.HIGH_CAPACITY_ICE, Icons.UPRIGHT_PIZZA_STORAGE],
    C: [Icons.HIGH_CAPACITY_ICE, Icons.UPRIGHT_PIZZA_STORAGE, Icons.FAST_CHILL],
  },
  334604915: {
    B: [Icons.ICE_MAKER, Icons.TEMPERATURE_CONTROL, Icons.FAST_COOLING],
    C: [Icons.HIGH_CAPACITY_ICE, Icons.FAST_COOLING, Icons.UPRIGHT_PIZZA_STORAGE],
  },
  334801382: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.TEMPERATURE_CONTROL, Icons.UPRIGHT_PIZZA_STORAGE],
    C: [Icons.ONE_ONE_LBS_ICE_CAPACITY, Icons.UPRIGHT_PIZZA_STORAGE, Icons.FAST_CHILL],
  },
  335050415: {
    B: [Icons.FAST_ICE_ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.FAST_ICE_FAST_ICE_PRODUCTION, Icons.ODOR_FILTER, Icons.HUMIDITY_CONTROL],
  },
  335144179: {
    B: [Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL, Icons.FAST_ICE_PRODUCTION],
    C: [Icons.FAST_ICE_PRODUCTION, Icons.UPRIGHT_PIZZA_STORAGE, Icons.PINT_STORAGE],
  },
  335241794: {
    B: [Icons.FAST_ICE_ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.FAST_ICE_FAST_ICE_PRODUCTION, Icons.ONE_TOUCH_BOTTLE_FILL, Icons.ODOR_FILTER],
  },
  337737839: {
    B: [Icons.ICE_MAKER, Icons.WATER_DISPENSER, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.INTERNAL_WATER_DISPENSER, Icons.AUTO_CLOSE_DOORS, Icons.AIR_FILTER],
  },
  337737888: {
    B: [Icons.ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.AUTO_CLOSE_DOORS],
    C: [Icons.AUTO_CLOSE_DOORS, Icons.THREE_TIER_FREEZER, Icons.ODOR_FILTER],
  },
  338038883: {
    B: [Icons.MEASURED_WATER_FILL, Icons.ADJUSTABLE_TEMP_DRAWER, Icons.FAST_COOL_AND_FREEZE],
    C: [Icons.PREP_STORAGE_BINS, Icons.FIVE_STORAGE_ZONES, Icons.PIZZA_STORAGE],
  },
  338063182: {
    B: [Icons.LARGE_CAPACITY_ICE_MAKER, Icons.DIGITAL_TEMP_CONTROL, Icons.CUSTOMIZABLE_HARDWARE],
    C: [Icons.CUSTOMIZABLE_HARDWARE, Icons.SLIDING_STORAGE_TRAY, Icons.FAST_ICE_PRODUCTION],
  },
  338095531: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.WI_FI_ENABLED, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.CONVERTIBLE_DRAWER, Icons.WI_FI_ENABLED, Icons.WATER_AND_ICE_DISPENSER],
  },
  338101599: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.COUNTER_DEPTH, Icons.TEMPERATURE_CONTROL],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.COUNTER_DEPTH, Icons.FAST_ICE_FAST_ICE_PRODUCTION],
  },
  338733566: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.PRECISE_TEMP_CONTROL, Icons.HIDDEN_WATER_DISPENSER, Icons.AIR_FILTER],
  },
  338983656: {
    B: [Icons.ICE_MAKER, Icons.WATER_DISPENSER, Icons.TEMPERATURE_CONTROL],
    C: [Icons.SEVEN_LBS_ICE_CAPACITY, Icons.INTERNAL_WATER_DISPENSER, Icons.PINT_STORAGE],
  },
  339267365: {
    B: [Icons.ICE_MAKER, Icons.CONVERTIBLE_COMPARTMENT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.ADJUSTABLE_TEMP_DRAWER, Icons.PIZZA_STORAGE, Icons.SIX_ZERO_FOUR_ZERO_PRODUCE_DRAWERS],
  },
  340083665: {
    B: [Icons.INTERNAL_ICE_DISPENSER, Icons.FINGERPRINT_RESISTANT, Icons.INDEPENDENT_TEMP_CONTROLS],
    C: [Icons.DUAL_COOLING_COOLING_SYSTEM, Icons.FIVE_FIVE_LBS_ICE_CAPACITY, Icons.INTERNAL_ICE_DISPENSER],
  },
  340113318: {
    B: [Icons.ICE_MAKER, Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL],
    C: [Icons.NESTING_SHELF, Icons.FRESHNESS_SYSTEM, Icons.FAST_CHILL],
  },
  340452027: {
    B: [Icons.FINGERPRINT_RESISTANT, Icons.TEMPERATURE_CONTROL, Icons.FAST_CHILL_AND_FREEZE],
    C: [Icons.FINGERPRINT_RESISTANT, Icons.FAST_CHILL_AND_FREEZE, Icons.EVEN_COOLING],
  },
  340640990: {
    B: [Icons.WATER_AND_ICE_DISPENSER, Icons.WI_FI_ENABLED, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.FOUR_ICE_TYPES, Icons.TALL_DISPENSER, Icons.WI_FI_ENABLED],
  },
  340641172: {
    B: [Icons.ICE_MAKER, Icons.WI_FI_ENABLED, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.WI_FI_ENABLED, Icons.TALL_DISPENSER, Icons.SLIDE_IN_SHELF],
  },
  340641189: {
    B: [Icons.ICE_MAKER, Icons.WI_FI_ENABLED, Icons.FINGERPRINT_RESISTANT],
    C: [Icons.WI_FI_ENABLED, Icons.ENERGY_SAVING_MODE, Icons.SLIDE_IN_SHELF],
  },
  340641194: {
    B: [Icons.WI_FI_ENABLED, Icons.FINGERPRINT_RESISTANT, Icons.DIGITAL_TEMP_CONTROL],
    C: [Icons.WI_FI_ENABLED, Icons.ENERGY_MONITORING, Icons.SLIDE_IN_SHELF],
  },
  341610440: {
    B: [Icons.DUAL_ICE_MAKER_ICE_MAKER, Icons.WI_FI_ENABLED, Icons.COUNTER_DEPTH],
    C: [Icons.DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS, Icons.TALL_DISPENSER, Icons.WI_FI_ENABLED],
  },
};

export const getIconsByItemId = (itemId, variant = 'C') => (
  itemIdToIconsMap[itemId]?.[variant] ?? []
);
